'use client';

import Image from 'next/image';
import React, { ReactNode } from 'react';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import CustomRichText from '../CustomRichText';

export interface ProposalListBlockProps {
  id?: string;
  title: ReactNode | SerializedEditorState;
  content: ReactNode | SerializedEditorState;
  image: string | { url: string; alt: string };
  showRocket?: boolean;
}

export default function TxtWithImageBlockV2({
  title,
  content,
  image,
  id,
  showRocket,
}: ProposalListBlockProps) {
  return (
    <div id={id} data-meta="TxtWithImageBlockV2" className="container max-w-7xl mx-auto my-14">
      <div className="px-4 py-5 sm:px-6 flex justify-center">
        <CustomRichText
          data={title}
          tag="div"
          className="text-4xl xl:text-6xl mb-4 xl:mb-8 font-bold text-center text-white"
        />
      </div>
      <div className="mb-8 bg-white rounded-[2rem] overflow-hidden flex flex-col justify-center lg:grid lg:grid-cols-12 lg:gap-4 gap-2">
        <div className="flex flex-col col-span-6 justify-between p-8">
          <CustomRichText data={content} tag="div" className="max-lg:text-xs" />
          {showRocket && (
            <div className="flex mt-8 md:mt-0 gap-2 justify-end">
              <Image src={'/assets/photoHero/Rocket.webp'} alt={''} width={150} height={100} />
            </div>
          )}
        </div>
        <Image
          alt={''}
          src={typeof image === 'string' ? image : image?.url}
          sizes="auto"
          width={780}
          height={550}
          style={{
            width: '100%',
            height: 'auto',
          }}
          className="lg:col-span-6 object-contain lg:translate-x-4"
        />
      </div>
    </div>
  );
}
